<template lang="html">
  <div class="container-fluid">
    <d-row class="p-2">
      <d-col md="8">
        <form class="main-sidebar__search w-100 d-flex">
          <div class="input-group input-group-seamless">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="fas fa-search"></i>
              </div>
            </div>
            <d-form-input
              class="navbar-search"
              type="text"
              placeholder="Procurar por algo..."
              aria-label="Search"
              v-model="pagination.search"
              @input="search"
            ></d-form-input>
          </div>
        </form>
      </d-col>
      <d-col md="4">
        <d-button class="btn btn-success text-white float-right" @click="uploadFile">Anexar arquivos</d-button>
      </d-col>
    </d-row>
    <d-row class="row-table">
      <d-col class="col-table">
        <table class="table mb-0 table-striped">
          <thead class="bg-light">
            <tr>
              <th scope="col" class="td-1 border-0">#</th>
              <th scope="col" class="text-left border-0">Nome</th>
              <th scope="col" class="td-2 border-0">Opções</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(file, index) in fileList" :key="index">
              <td>{{ file.id }}</td>
              <td class="text-left">{{ file.name }}</td>
              <td>
                <d-button-group class="buttons">
                  <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow(file.file_id)">
                    <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
                  </d-button>
                  <d-link size="sm" class="btn btn-success" :href="file.file.url" target="_blank">
                    <i class="fas fa-download"></i><span class="d-none d-lg-inline"> Download</span>
                  </d-link>
                </d-button-group>
              </td>
            </tr>
            <tr v-if="fileList.length === 0" class="drag-row align-items-center">
              <td colspan="3" class="no-content">Ainda não tem nenhum arquivo atribuido.</td>
            </tr>
          </tbody>
        </table>
      </d-col>
    </d-row>
    <upload-project-file :project-id="pagination.projectId"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import UploadProjectFile from './UploadProjectFile.vue';
import { _SAVE_PROJECT_FILE_SUCCESS_, _OPEN_CONFIRMATION_ } from '../ProjectModel';

export default {
  name: 'project-files',
  components: {
    UploadProjectFile,
  },
  props: {},
  data() {
    return {
      timer: null,
      pagination: {
        search: '',
        projectId: parseInt(this.$route.params.projectId, Number),
      },
    };
  },
  computed: {
    fileList() {
      const { fileList } = this.$store.state.project;
      if (fileList && fileList.length > 0) {
        return fileList;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getFile',
    ]),
    confirmDeleteRow(fileId) {
      this.setToggle({ type: 'confirm_modal', bool: true });
      const project = {
        id: this.pagination.projectId,
        fileId,
      };
      Events.$emit(_OPEN_CONFIRMATION_, { project, type: 'deleteFile' });
    },
    search() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.getFile(this.pagination);
      }, 500);
    },
    uploadFile() {
      this.setToggle({ type: 'upload_file_modal', bool: true });
    },
  },
  mounted() {
    this.getFile(this.pagination);
    Events.$on(_SAVE_PROJECT_FILE_SUCCESS_, () => {
      this.getFile(this.pagination);
    });
  },
};
</script>

<style lang="scss" scoped>
.td-1 {
  width: 5%;
}
.td-2 {
  width: 15%;
}
</style>
